<template>
  <div class="container">
    <HeaderComponent />
    <main class="m-6">
      <LoggingComponent class="table"></LoggingComponent>
    </main>
    <FooterComponent class="footer bottom-0"></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import LoggingComponent from "@/components/LoggingComponent.vue";

export default {
  name: "LoggingView",
  components: {
    HeaderComponent,
    FooterComponent,
    LoggingComponent,
  },
  created() {},
};
</script>
<style scoped>
body{
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}
#content-wrap {
  padding-bottom: 2.5rem;    /* Footer height */
}

#footer {
    bottom: 0;
  width: 100%;
  height: 9rem;         
  background-color: white;   /* Footer height */
}

#table {
  margin-bottom: 13rem;            /* Footer height */
}
</style>
